import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from '../../../rootStyles/Content.module.css'
import Header from '../../../components/Header/Header'
import { Methods } from '../../../constants/Methods'

const Content = () => {

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)
    
    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme ?? 'light'].background
            }}
        >
            <Header
                leftIcon={null}
                leftPath={null}
                leftClick={null}
                title={Strings[language ?? 'tm'].aboutUs}
                rightIcon={null}
                rightPath={null}
                rightClick={null}
            />
            <div
                className={style.content}
            >
                <div className={style.textsContainer}>

                    <span
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].app
                        }}
                    >
                        {Strings[language ?? 'tm'].appDescription1}
                    </span>
                    <span
                        className={style.subtitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appDescription2}
                    </span>
                    <span
                        className={style.subtitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appDescription3}
                    </span>

                    {/* ABOUT US */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUs}
                    </span>
                    
                    {/* 1. ABOUT US */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUs1}
                    </span>
                    
                    {/* 2. ABOUT US */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUs2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsServices}
                    </span>
                    


                    {/* QUESTIONS AND ANSWERS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsQuestionsAndAnswers}
                    </span>
                    
                    {/* 1. QUESTIONS AND ANSWERS */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsQuestion1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsAnswer1}
                    </span>
                        
                    {/* 2. QUESTIONS AND ANSWERS */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsQuestion2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsAnswer2}
                    </span>
                        
                    {/* 3. QUESTIONS AND ANSWERS */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsQuestion3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appAboutUsAnswer3}
                    </span>
                        


                    {/* SUPPORTS AND CONTACTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appSupport}
                    </span>
                    <a
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                        href="mailto:lezzetsebeti@gmail.com"
                    >
                        {Strings[language ?? 'tm'].email}: lezzetsebeti@gmail.com
                    </a>
                    <a
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                        href="tel:+99371814745"
                    >
                        {Strings[language ?? 'tm'].phone}: {Methods.getNextPhone('+993 71814745')}
                    </a>

                    <span
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].app
                        }}
                    >
                        {Strings[language ?? 'tm'].copyright}
                    </span>
                        
                </div>
            </div>
        </div>
    )
}

export default Content